import { CSSProperties } from 'react';
import UIConfig from '@/UIConfig.ts';

export const unreadIndicatorStyle: CSSProperties = {
  position: 'absolute',
  right: '20px',
  top: '36px',
  width: '10px',
  height: '10px',
  background: '#000',
  borderRadius: '5px'
};

export const pendingGiftIndicatorStyle: CSSProperties = {
  position: 'absolute',
  right: '20px',
  top: '30px',
  padding: '4px 8px',
  background: '#000',
  borderRadius: '12px',
  color: '#fff',
  fontSize: '10px',
  fontWeight: 600,
  lineHeight: '16px',
  textAlign: 'center'
};

export const nameStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  paddingBottom: 5,
  paddingLeft: 2,
  margin: '0px',
  fontWeight: 500,
  lineHeight: 1,
  minWidth: 0
};

export const messageContainerStyle: CSSProperties = {
  paddingLeft: 2,
  paddingTop: 5,
  margin: '0px',
  overflow: 'hidden',
  alignItems: 'center',
  display: 'flex',
  width: '100%'
};

export const messageTextStyle: CSSProperties = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  fontSize: '14px',
  maxWidth: '80%'
};

export const containerStyle: CSSProperties = {
  width: '100%',
  height: '72px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: '10px',
  marginBottom: '10px',
  position: 'relative'
};

export const dialogContainerStyle: CSSProperties = {
  width: 'calc(100% - 100px)',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-start',
  flexDirection: 'column',
  position: 'relative'
};

export const imageContainerStyle: CSSProperties = {
  width: '100px',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'relative'
};

const indicationStyle: CSSProperties = {
  width: '14px',
  height: '14px',
  borderRadius: '10px',
  position: 'absolute',
  bottom: '2px',
  right: '9px',
  border: `3px solid ${UIConfig.Colors.BackgroundWhite}`
};

export const activeIndicatorStyle: CSSProperties = {
  background: '#07B9B6',
  ...indicationStyle
};

export const seenRecentlyIndicatorStyle: CSSProperties = {
  background: '#ff8000',
  ...indicationStyle
};

export const imageStyle: CSSProperties = {
  width: '72px',
  height: '72px',
  borderRadius: '50px',
  marginLeft: '5px',
  objectFit: 'cover'
};

export const noImageStyle: CSSProperties = {
  display: 'flex',
  fontSize: '9px',
  color: 'rgb(0 0 0 / 25%)',
  fontWeight: 'bold',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center'
};

export const separatorStyle: CSSProperties = {
  position: 'absolute',
  bottom: -10,
  left: 0,
  right: '40px',
  height: '1px',
  backgroundColor: '#e3e3e3',
  opacity: 0.7
};

export const chatRequestBadge: CSSProperties = {
  backgroundColor: '#FF7373',
  color: '#FFF',
  fontSize: '9px',
  fontWeight: '600',
  padding: '5px 10px',
  borderRadius: '12px'
};
